import { render, staticRenderFns } from "./ReporteIncapacidadAP.vue?vue&type=template&id=fb5d0720"
import script from "./ReporteIncapacidadAP.vue?vue&type=script&lang=js"
export * from "./ReporteIncapacidadAP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports